<section class="bg-black-mail"  *ngIf="emaildata?.length > 0">
  <div class="container no-btn-wrap py-4">
    <div class="col-12">
      <div class="row align-items-center justify-content-center mb-4">
        <div class="col-12 col-md-7 col-lg-6">
          <div [innerHTML]="index9?.short_description || ''"></div>
        </div>
        <div class="col-12 col-md-5">
          <form [formGroup]="emailForm" (ngSubmit)="onSubmit.emit()">
            <div class="position-relative">
              <input class="form-control kds-mail" id="email_address_id" name="email_address_id"
                placeholder="Enter Email" type="email" aria-label="Email" formControlName="email" />
              <button class="green-btn position-absolute top-50 end-0 translate-middle-y me-lg-2" type="submit">
                <i class="fa fa-angle-right green-arrow"></i>
              </button>
            </div>
          </form>
          <div class="error-msg" *ngIf="errorMessage">
            {{ errorMessage }}
          </div>
        </div>
      </div>
      <div class="green-border"></div>
    </div>
  </div>
</section>

